export default {"src":"/_next/static/media/passLogo.0da6aeca.svg","height":18,"width":18};